//
//
//
//

export default {
    name: "order-confirm"
}



// WEBPACK FOOTER //
// ./src/components/order/OrderConfirm.vue